import React from 'react';

export interface IdiomaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const IdiomaIcon: React.FC<IdiomaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="m16.085 6.446-5.392 12.141"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="m15.482 18.59 3.02-6.723 3.039 6.72m-4.606-2.521h3.188"/><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="M3.324 6.295h7.358m-6.786 5.57c1.317-.53 4.403-2.786 5.197-5.57"/><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" d="M5.467 8.315c.575.997 2.88 2.574 5.094 2.644M7.478 4.56v1.737"/>
    </svg>
  );
};

export default IdiomaIcon;
